/**
 * @package WP_smartpath
 * @version 1.0.0
 */

function postSlide () {
	$( '.hero' ).addClass( 'full-height' )
	$( '.hero-info, #page-content, #sidebar' ).addClass( 'd-none d-md-none d-lg-none' )
	$( '.smartpath' ).addClass( 'mx-auto' )
}
window.postSlide = postSlide



// WEBPACK FOOTER //
// ./scripts/plugins/wp-smartpath/index.js